import { useEffect, useState } from "react";
import { Item, ItemService, tableSchema } from "../../services/Item";
import './processFlow.css'
import "gantt-task-react/dist/index.css";
import { useParams } from "react-router-dom";
import { Timeline } from "antd";
import { Tool } from "../../services/Tool";

function ProcessFlow({item}: {item: Item}) {

    const params = useParams()
    const [timelineItems, setTimelineItems] = useState<any[]>([])

    useEffect(() => {
        if (item) {
            let timelineAll: any[] = [];
            timelineAll = timelineAll.concat(
                getItems(item.tablePlanning || []),
                getItems(item.tableBids || []),
                getItems(item.tableEvaluation || []),
                getItems(item.tableCommitteeReview || []),
                getItems(item.tableContractAward || []),
                getItems(item.tableContractManagement || [])
            );
            setTimelineItems(timelineAll)
        } else {
            setTimelineItems([])
        }

    }, [item])

    const getItems = (table: tableSchema[]) => {
        let data = table.filter( d => d.flowInclude);
        if (data?.length) {
            const timeline = []
            for (let i = 0; i < data.length; i++) {
                const duration: string = data[i].triggerStage ? data[i].triggerStage : '1';
                timeline.push({
                    color: (data[i].application as Tool)?.color || '#006eb5',
                    key: data[i]._id,
                    children:
                        <div  className="timeline-item-custom" style={{ backgroundColor: (data[i].application as Tool)?.color || '#006eb5' }}>
                            {data[i].action + ' (' + duration + ' days)'}
                        </div>
                })

            }
            return timeline;
        } else {
            return []
        }
    }

    return (
        <div>
            {(timelineItems.length > 0) &&
                <div>
                    <div className="proces-flow-title">
                        Process Steps
                    </div>

                    <Timeline
                        style={{ marginTop: 32, maxWidth: 800 }}
                        items={timelineItems}
                    />
                </div>
            }
        </div>
    );
}

export default ProcessFlow;